import {API_URL, authHeaders} from "./index";

export async function apiGetDashboard() {
    const res = await fetch(`${API_URL}/admin/dashboard`, {headers: authHeaders()});
    return res.json();
}

export async function apiGetDomains() {
    const res = await fetch(`${API_URL}/admin/domains`, {headers: authHeaders()});
    return res.json();
}

export async function apiAddDomain(domain) {
    const res = await fetch(`${API_URL}/admin/domains`, {
        method: "POST",
        headers: {...authHeaders(), "Content-Type": "application/json"},
        body: JSON.stringify({domain}),
    });
    return res.json();
}

export async function apiDeleteDomain(id) {
    const res = await fetch(`${API_URL}/admin/domains/${id}`, {
        method: "DELETE",
        headers: authHeaders(),
    });
    return res.json();
}

export async function apiGetWaitlist() {
    const res = await fetch(`${API_URL}/admin/waitlist`, {headers: authHeaders()});
    return res.json();
}

export async function apiProcessWaitlist() {
    const res = await fetch(`${API_URL}/admin/waitlist/process`, {
        method: "POST",
        headers: authHeaders(),
    });
    return res.json();
}
